import { NgClass, CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';

@Component({
    selector: 'app-error-code-details',
    templateUrl: './error-code-details.component.html',
    imports: [CommonModule, MatDividerModule, NgClass, FormsModule, ReactiveFormsModule, MatListModule],
    styleUrls: ['./error-code-details.component.scss']
})
export class ErrorCodeDetailsComponent implements OnInit {

  @Input('ExceptionCodesDetails') ExceptionCodesDetails: any=[];
  constructor() { } 

  ngOnInit() {
  }

}
